import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 位 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form_item, { label: "提示文字" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx._placeholder,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx._placeholder) = $event)),
          size: "default",
          placeholder: "请设置提示语"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { label: "保留小数" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input_number, {
          modelValue: _ctx._value.precision,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx._value.precision) = $event)),
          "controls-position": "right",
          precision: 0,
          max: 3,
          min: 0,
          size: "default",
          placeholder: "小数位数"
        }, null, 8, ["modelValue"]),
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_el_form_item, { label: "展示大写" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_switch, {
          modelValue: _ctx._value.showChinese,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx._value.showChinese) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}